import { render, staticRenderFns } from "./CheckLabelPicture.vue?vue&type=template&id=4f10b432"
import script from "./CheckLabelPicture.vue?vue&type=script&lang=js"
export * from "./CheckLabelPicture.vue?vue&type=script&lang=js"
import style0 from "./CheckLabelPicture.vue?vue&type=style&index=0&id=4f10b432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports